// pylee/apps/web/app/(home)/components/cta.tsx
import styles from './cta.module.css';
// import DemoRequestForm from './demo-request-form';

// Define default values as constants for better maintainability
// const DEFAULT_FORM_ACTION = 'https://formspree.io/f/mjkyaypq';
const DEFAULT_CALENDLY_LINK = 'https://calendly.com/bucephalus/pylee-demo';

// Define props interface for type safety and clarity
interface CTAProps {
  /** Optional action URL for the demo request form */
  // formAction?: string;
  /** Optional link for scheduling a demo via Calendly */
  calendlyLink?: string;
}

/**
 * Call-to-Action (CTA) component encouraging users to request a demo
 * or schedule one directly.
 */
const CTA = ({
  // formAction = DEFAULT_FORM_ACTION,
  calendlyLink = DEFAULT_CALENDLY_LINK,
}: CTAProps) => { // Use the defined interface for props typing
  return (
    <section id="cta" className={`content-section ${styles.ctaSection}`}>
      <div className="page-container">
        <h2 className="section-heading">
          Start Building <span>Better</span> with AI
        </h2>
        <p className="section-subheading">
          Join forward-thinking teams using Pylee to accelerate their AI capabilities securely, whether on your infrastructure or ours.
        </p>

        {/* Container for the primary CTA actions */}
        <div className={styles.ctaActionsContainer}>
          {/* CTA Button */}
          <a
            href="https://app.pyleeai.com/?utm_source=website&utm_medium=cta&utm_campaign=primary_signup"
            className={`btn btn-primary ${styles.primaryCtaBtn}`}
            data-event="sign_up"
            data-event-location="bottom_cta"
          >
            GET STARTED FREE
          </a>
          
          <div className={styles.formDisclaimer}>
            No credit card required. 
            Start using Pylee instantly or schedule a chat.
          </div>

          {/* Direct Calendly Link Button */}
          <a
            href={calendlyLink} // Pass the Calendly link URL
            target="_blank"          // Open in a new tab
            rel="noopener noreferrer" // Security best practice for target="_blank"
            className={`btn btn-secondary ${styles.calendlyLinkBtn}`}
          >
            Schedule Demo Directly
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;